export const InfoIcon = () => (
    <svg
        data-testid={'infoIcon'}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM11.9965 9.40001C12.1655 9.40001 12.3084 9.45717 12.425 9.57149C12.5417 9.68582 12.6 9.82749 12.6 9.99649C12.6 10.1655 12.5429 10.3083 12.4285 10.425C12.3142 10.5417 12.1725 10.6 12.0035 10.6C11.8345 10.6 11.6917 10.5428 11.575 10.4285C11.4584 10.3142 11.4 10.1725 11.4 10.0035C11.4 9.83451 11.4572 9.69167 11.5715 9.57501C11.6858 9.45834 11.8275 9.40001 11.9965 9.40001ZM12.6 12V14C12.6 14.3314 12.3314 14.6 12 14.6C11.6687 14.6 11.4 14.3314 11.4 14V12C11.4 11.6686 11.6687 11.4 12 11.4C12.3314 11.4 12.6 11.6686 12.6 12Z"
            fill="#0288D1"
        />
    </svg>
);
